var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.driver + '-form',{tag:"div",attrs:{"errors":_vm.errors},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }